module.exports = __webpack_public_path__ + "pic/61.653b4a30.png";